// skipcq: JS-W1028
import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { UserContext } from '../context/UserContext';
import PageLoadingIndicator from '../components/widgets/PageLoadingIndicator';
import { peekClaimBreweryHandoff } from '../utils/claimBreweryHandoff';

function isBreweryClaimPath(pathname) {
  return pathname === '/brewery-portal/claim' || pathname.startsWith('/brewery-portal/claim/');
}

/**
 * Verified brewers only. Global admins use the dashboard, except while an app
 * claim handoff is letting them open the claim form.
 */
export default function BreweryPortalRoute({ children }) {
  const user = useContext(UserContext);
  const location = useLocation();
  const onClaimRoute = isBreweryClaimPath(location.pathname);
  // The claim page removes the id from sessionStorage, then keeps it in memory
  // until that page unmounts. Peek stays true for the visit, including re-renders.
  const allowGlobalAdminClaim = onClaimRoute && peekClaimBreweryHandoff().length > 0;

  if (user.isLoading) {
    return <PageLoadingIndicator title="Loading..." />;
  }

  if (!user.isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (user.emailVerified !== true) {
    return <Navigate to="/verify-email" replace />;
  }

  if (user.isGlobalAdmin && !allowGlobalAdminClaim) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
